const updatePlaylistDisplayHubs = (
  update: PlaylistDisplayHub[],
  current: PlaylistDisplayHub[] | null
) => {
  if (!current) return current;
  const result = current.map((playlistDisplayHub) => {
    const updatedPlaylistDisplayHub = update.find((p) => p.id === playlistDisplayHub.id);
    if (updatedPlaylistDisplayHub) {
      return updatedPlaylistDisplayHub;
    }
    return playlistDisplayHub;
  });

  return result;
};

export { updatePlaylistDisplayHubs };
